import styled from 'styled-components';
import { TitleWithBenefitsTemplate } from '@components/v2/TitleWithBenefits/TitleWithBenefitsTemplate';
import { rem } from 'polished';

export const TitleWithBenefitsStyled = styled(TitleWithBenefitsTemplate)`
    display: flex;
    flex-direction: column;
    margin-top: ${rem('15px')};

    button {
        &:focus-visible {
            .link {
                border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .title {
        font-weight: bold;
        font-size: ${({ theme }) => theme.fontSizes.h4};
    }

    .benefits {
        margin-top: ${rem('30px')};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        padding: ${rem('20px')} ${rem('20px')} ${rem('8px')} ${rem('20px')};
        background: ${({ theme }) => theme.colors.grey7};

        .heading {
            font-weight: bold;
        }

        .bullet-points {
            margin: ${rem(8)} 0;

            &.disable-bullet-points {
                padding-left: 0;

                li {
                    list-style: none;
                }
            }

            &.allow-bullet-points {
                padding: 0 0 0 ${rem('10px')};
            }
        }

        .bullet-points.allow-bullet-points {
            .offer svg {
                circle {
                    fill: ${({ theme }) => theme.colors.grey2};
                    stroke: ${({ theme }) => theme.colors.grey2};
                }
            }
        }
    }

    .specs {
        display: flex;
        margin-top: ${rem('10px')};

        .specs-title {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        }
    }

    .info-icon-container {
        position: absolute;
        bottom: ${rem(4)};
        right: 0;
    }

    .offer {
        & > div:first-child {
            padding-right: ${rem(16)};
        }
    }
`;
